<div class="otp-toast" *ngIf="displayInfoMessage" 
     [ngClass]="{'otp-toast--success': infoMessage.bgColor === '#55BA45', 'otp-toast--error': infoMessage.bgColor === '#E24A47'}">
    <div class="otp-toast__icon">
        <i [class]="infoMessage.icon"></i>
    </div>
    <div class="otp-toast__content">
        <div class="otp-toast__title">{{ infoMessage.bgColor === '#55BA45' ? 'Successful' : 'Error' }}</div>
        <div class="otp-toast__message">{{ infoMessage.message }}</div>
    </div>
    <button class="otp-toast__close" (click)="displayInfoMessage = false">
        <i class="pi pi-times"></i>
    </button>
</div>

<div *ngIf="testNotAvailable" class="otp-warning-overlay">
    <div class="otp-warning">
        <div class="otp-warning__icon">
            <img src="./assets/icons-svg/Warning.svg" alt="Warning"/>
        </div>
        <div class="otp-warning__title">NOTE!</div>
        <div class="otp-warning__text">{{testErrorMessage}}</div>
    </div>
</div>

<div class="otp-page" *ngIf="!testNotAvailable">
    <div class="otp-card">
        <div class="otp-verifying" *ngIf="isVerifying">
            <div class="otp-verifying__content">
                <div class="otp-verifying__spinner"></div>
                <h2 class="otp-verifying__title">Your space, almost here!</h2>
                <p class="otp-verifying__text">Please wait while we verify your details...</p>
                <div class="otp-verifying__progress">
                    <div class="otp-verifying__progress-bar"></div>
                </div>
            </div>
        </div>

        <div *ngIf="!isVerifying">
            <ng-container *ngIf="verifyCategory === 'test'">
                <ng-template #testSendOtpNote>
                    <div class="otp-test-send-note">
                        <span class="otp-test-send-note__icon" aria-hidden="true">
                            <i class="pi pi-info-circle"></i>
                        </span>
                        <p class="otp-test-send-note__text">
                            OTP may take up to {{ otpDeliveryExpectationMinutes }} minutes to arrive. Please wait and avoid refreshing or requesting again.
                        </p>
                    </div>
                </ng-template>

                <div class="otp-avatar" *ngIf="!pageLoading">
                    <span class="otp-avatar__letter">{{ candidateName ? candidateName.charAt(0).toUpperCase() : '' }}</span>
                </div>

                <div class="otp-header" *ngIf="!pageLoading">
                    <h1 class="otp-header__title">
                        Welcome, <span class="otp-header__title--highlight">{{candidateName}}</span>
                    </h1>
                    <p class="otp-header__subtitle">Please verify your email to start your test</p>
                </div>

                <div class="otp-info-list" *ngIf="!pageLoading">
                    <div class="otp-info-item">
                        <div class="otp-info-item__icon">
                            <i class="pi pi-building"></i>
                        </div>
                        <div class="otp-info-item__content">
                            <span class="otp-info-item__label">Company Name</span>
                            <span class="otp-info-item__value">{{CompanyName}}</span>
                        </div>
                    </div>
                    <div class="otp-info-item">
                        <div class="otp-info-item__icon">
                            <i class="pi pi-graduation-cap"></i>
                        </div>
                        <div class="otp-info-item__content">
                            <span class="otp-info-item__label">Test Name</span>
                            <span class="otp-info-item__value">{{testName}}</span>
                        </div>
                    </div>
                    <div class="otp-info-item">
                        <div class="otp-info-item__icon">
                            <i class="pi pi-clock"></i>
                        </div>
                        <div class="otp-info-item__content">
                            <span class="otp-info-item__label">Test Duration</span>
                            <span class="otp-info-item__value">{{testDuration}} minutes</span>
                        </div>
                    </div>
                </div>

                <div class="otp-form-group" *ngIf="!pageLoading && sendOtpState">
                    <label class="otp-label">
                        <i class="pi pi-envelope"></i>
                        <span>Email ID</span>
                    </label>
                    <input [(ngModel)]="emailToVerify" 
                           [placeholder]="emailToVerify" 
                           class="otp-input" 
                           type="email" 
                           pInputText 
                           [disabled]="true"/>
                </div>

                <div class="otp-form-group" *ngIf="!pageLoading && verifyOtpState">
                    <label class="otp-label">
                        <i class="pi pi-lock"></i>
                        <span>Enter OTP</span>
                    </label>
                    <div class="otp-digits" (paste)="onOtpPaste($event)">
                        <input *ngFor="let digit of otpInputs; let i = index"
                               type="text"
                               maxlength="1"
                               [(ngModel)]="otpDigits[i]"
                               (input)="onOtpInput($event, i)"
                               (keydown)="onOtpKeyDown($event, i)"
                               class="otp-digit"
                               #otpInput />
                    </div>
                    <span *ngIf="clicked && invalidOTP" class="otp-error">
                        Please enter the valid OTP sent to your email ID
                    </span>
                    <span *ngIf="clicked && expiredOTP" class="otp-error">OTP Expired</span>
                </div>

                <div class="otp-resend" *ngIf="!pageLoading && verifyOtpState">
                    <span class="otp-resend__hint">Please enter 6 digit OTP</span>
                    <ng-container *ngIf="waitToResend || sendOtpDisabled">
                        <span class="otp-resend__timer">
                            Resend in <strong>{{sendOtpDisabled && cooldownTimer > 0 ? cooldownTimer : countdown}}s</strong>
                        </span>
                    </ng-container>
                    <button *ngIf="!waitToResend && !sendOtpDisabled" 
                            (click)="resendOtp()" 
                            class="otp-resend__btn"
                            [disabled]="loadResend">
                        <span *ngIf="!loadResend">Resend</span>
                        <p-progressSpinner *ngIf="loadResend" 
                                           [style]="{height: '16px', width: '16px'}" 
                                           strokeWidth="7"
                                           animationDuration="0.5s">
                        </p-progressSpinner>
                    </button>
                </div>

                <button *ngIf="sendOtpState && !pageLoading" 
                        class="otp-btn" 
                        [disabled]="btnLoading || sendOtpDisabled" 
                        (click)="sendTestOtp()">
                    <span *ngIf="!btnLoading && !sendOtpDisabled" class="otp-btn__content">
                        <span>Send OTP</span>
                        <i class="pi pi-arrow-right"></i>
                    </span>
                    <span *ngIf="sendOtpDisabled && cooldownTimer > 0">Please wait {{cooldownTimer}}s</span>
                    <span *ngIf="btnLoading && !sendOtpDisabled" class="otp-btn__content">
                        <span class="otp-spinner"></span>
                        <span>Sending...</span>
                    </span>
                </button>

                <ng-container *ngIf="sendOtpState && !pageLoading">
                    <ng-container *ngTemplateOutlet="testSendOtpNote"></ng-container>
                </ng-container>

                <button *ngIf="verifyOtpState && !pageLoading" 
                        class="otp-btn" 
                        [disabled]="btnLoading || otpValue?.length != 6" 
                        (click)="verifyOtp()">
                    <span *ngIf="!btnLoading" class="otp-btn__content">
                        <span>Verify</span>
                        <i class="pi pi-arrow-right"></i>
                    </span>
                    <span *ngIf="btnLoading" class="otp-btn__content">
                        <span class="otp-spinner"></span>
                        <span>Verifying...</span>
                    </span>
                </button>

                <ng-container *ngIf="verifyOtpState && !pageLoading">
                    <ng-container *ngTemplateOutlet="testSendOtpNote"></ng-container>
                </ng-container>
            </ng-container>

            <!-- Walk-in assessment mode: same UI as the test branch, but the candidate
                 enters their own email, then a shared access key (no OTP / no resend). -->
            <ng-container *ngIf="verifyCategory === 'walkin'">
                <div class="otp-avatar" *ngIf="!pageLoading" [class.otp-avatar--logo]="companyLogo">
                    <img *ngIf="companyLogo" [src]="companyLogo" alt="Company logo" class="otp-avatar__logo" />
                    <span *ngIf="!companyLogo" class="otp-avatar__letter">{{ CompanyName ? CompanyName.charAt(0).toUpperCase() : '' }}</span>
                </div>

                <div class="otp-header" *ngIf="!pageLoading">
                    <h1 class="otp-header__title">Welcome</h1>
                    <p class="otp-header__subtitle">
                        {{ sendOtpState ? 'Please enter your email to start your test' : 'Please enter the access key shared at the venue to start your test' }}
                    </p>
                </div>

                <div class="otp-info-list" *ngIf="!pageLoading">
                    <div class="otp-info-item">
                        <div class="otp-info-item__icon">
                            <i class="pi pi-building"></i>
                        </div>
                        <div class="otp-info-item__content">
                            <span class="otp-info-item__label">Company Name</span>
                            <span class="otp-info-item__value">{{CompanyName}}</span>
                        </div>
                    </div>
                    <div class="otp-info-item">
                        <div class="otp-info-item__icon">
                            <i class="pi pi-graduation-cap"></i>
                        </div>
                        <div class="otp-info-item__content">
                            <span class="otp-info-item__label">Test Name</span>
                            <span class="otp-info-item__value">{{testName}}</span>
                        </div>
                    </div>
                    <div class="otp-info-item">
                        <div class="otp-info-item__icon">
                            <i class="pi pi-clock"></i>
                        </div>
                        <div class="otp-info-item__content">
                            <span class="otp-info-item__label">Test Duration</span>
                            <span class="otp-info-item__value">{{testDuration}} minutes</span>
                        </div>
                    </div>
                </div>

                <div class="otp-form-group" *ngIf="!pageLoading && sendOtpState">
                    <label class="otp-label">
                        <i class="pi pi-envelope"></i>
                        <span>Email ID</span>
                    </label>
                    <input [(ngModel)]="emailToVerify"
                           placeholder="Enter your email ID"
                           class="otp-input"
                           type="email"
                           pInputText
                           (keyup.enter)="checkWalkInEligibility()"/>
                </div>

                <div class="otp-form-group" *ngIf="!pageLoading && verifyOtpState">
                    <label class="otp-label">
                        <i class="pi pi-lock"></i>
                        <span>Enter Access Key</span>
                    </label>
                    <div class="otp-digits" (paste)="onOtpPaste($event)">
                        <input *ngFor="let digit of otpInputs; let i = index"
                               type="text"
                               maxlength="1"
                               [(ngModel)]="otpDigits[i]"
                               (input)="onOtpInput($event, i)"
                               (keydown)="onOtpKeyDown($event, i)"
                               class="otp-digit"
                               #otpInput />
                    </div>
                    <span *ngIf="clicked && invalidOTP" class="otp-error">
                        Please enter the valid access key shared at the venue
                    </span>
                </div>

                <div class="otp-resend" *ngIf="!pageLoading && verifyOtpState">
                    <span class="otp-resend__hint">Please enter the 6 digit access key</span>
                </div>

                <button *ngIf="sendOtpState && !pageLoading"
                        class="otp-btn"
                        [disabled]="btnLoading || !emailToVerify"
                        (click)="checkWalkInEligibility()">
                    <span *ngIf="!btnLoading" class="otp-btn__content">
                        <span>Continue</span>
                        <i class="pi pi-arrow-right"></i>
                    </span>
                    <span *ngIf="btnLoading" class="otp-btn__content">
                        <span class="otp-spinner"></span>
                        <span>Verifying...</span>
                    </span>
                </button>

                <button *ngIf="verifyOtpState && !pageLoading"
                        class="otp-btn"
                        [disabled]="btnLoading || otpValue?.length != 6"
                        (click)="verifyWalkInKey()">
                    <span *ngIf="!btnLoading" class="otp-btn__content">
                        <span>Verify</span>
                        <i class="pi pi-arrow-right"></i>
                    </span>
                    <span *ngIf="btnLoading" class="otp-btn__content">
                        <span class="otp-spinner"></span>
                        <span>Verifying...</span>
                    </span>
                </button>
            </ng-container>

            <ng-container *ngIf="verifyCategory !== 'test' && verifyCategory !== 'walkin'">
                <div class="otp-icon-box" *ngIf="!pageLoading && sendOtpState">
                    <i class="pi pi-envelope"></i>
                </div>
                <div class="otp-icon-box" *ngIf="!pageLoading && verifyOtpState">
                    <i class="pi pi-lock"></i>
                </div>

                <!-- Header -->
                <div class="otp-header" *ngIf="!pageLoading">
                    <h1 class="otp-header__title" *ngIf="sendOtpState">Verify Your Email</h1>
                    <h1 class="otp-header__title" *ngIf="verifyOtpState">OTP Verification</h1>
                    <p class="otp-header__subtitle" *ngIf="sendOtpState">
                        We'll send a 6-digit code to verify your identity
                    </p>
                    <p class="otp-header__subtitle" *ngIf="verifyOtpState">
                        We have sent the code to <strong>{{emailToVerify}}</strong>
                    </p>
                </div>

                <ng-container *ngIf="mobileToVerify.length && enableMobile && !pageLoading">
                    <p class="otp-selection-text">
                        To continue with the verification process, kindly select either email ID or mobile number to verify and proceed.
                    </p>
                    <div class="otp-radio-group">
                        <div class="otp-radio">
                            <p-radioButton value="email" [(ngModel)]="_selectedCategory" [disabled]="verifyMail">
                            </p-radioButton>
                            <label class="otp-radio__label">Email ID</label>
                        </div>
                        <div class="otp-radio">
                            <p-radioButton value="mobile" [(ngModel)]="_selectedCategory" [disabled]="verifyMobile">
                            </p-radioButton>
                            <label class="otp-radio__label">Mobile Number</label>
                        </div>
                    </div>
                </ng-container>

                <div class="otp-form-group" *ngIf="!pageLoading && sendOtpState">
                    <label class="otp-label">
                        <i class="pi pi-envelope"></i>
                        <span>Email Address</span>
                    </label>
                    <input *ngIf="_selectedCategory == 'email'"
                           [(ngModel)]="emailToVerify" 
                           [placeholder]="emailToVerify" 
                           class="otp-input" 
                           type="email" 
                           pInputText 
                           [disabled]="true"/>
                    <input *ngIf="_selectedCategory == 'mobile'"
                           [(ngModel)]="mobileToVerify" 
                           class="otp-input" 
                           type="tel" 
                           pInputText 
                           [disabled]="true"/>
                </div>

                <div class="otp-form-group" *ngIf="!pageLoading && verifyOtpState">
                    <div class="otp-digits" (paste)="onOtpPaste($event)">
                        <input *ngFor="let digit of otpInputs; let i = index"
                               type="text"
                               maxlength="1"
                               [(ngModel)]="otpDigits[i]"
                               (input)="onOtpInput($event, i)"
                               (keydown)="onOtpKeyDown($event, i)"
                               class="otp-digit"
                               #otpInput />
                    </div>
                    <span *ngIf="clicked && invalidOTP" class="otp-error">
                        {{_selectedCategory == 'email' ? 'Please enter the valid OTP sent to your email ID' : 'Please enter the valid OTP sent to your mobile number'}}
                    </span>
                    <span *ngIf="clicked && expiredOTP" class="otp-error">OTP Expired</span>
                </div>

                <div class="otp-resend otp-resend--centered" *ngIf="!pageLoading && verifyOtpState">
                    <ng-container *ngIf="waitToResend || sendOtpDisabled">
                        <span class="otp-resend__timer">
                            Resend code in 
                            <span class="otp-resend__timer-value">
                                00:{{(sendOtpDisabled && cooldownTimer > 0 ? cooldownTimer : countdown).toString().padStart(2, '0')}}
                            </span>
                        </span>
                    </ng-container>
                    <button *ngIf="!waitToResend && !sendOtpDisabled" 
                            (click)="resendOtp()" 
                            class="otp-resend__btn"
                            [disabled]="loadResend">
                        <span *ngIf="!loadResend">Resend Code</span>
                        <p-progressSpinner *ngIf="loadResend" 
                                           [style]="{height: '16px', width: '16px'}" 
                                           strokeWidth="7"
                                           animationDuration="0.5s">
                        </p-progressSpinner>
                    </button>
                </div>

                <button *ngIf="sendOtpState && !pageLoading" 
                        class="otp-btn" 
                        [disabled]="btnLoading || sendOtpDisabled" 
                        (click)="sendOtpByEmail()">
                    <span *ngIf="!btnLoading && !sendOtpDisabled" class="otp-btn__content">
                        <span>Send Verification Code</span>
                        <i class="pi pi-arrow-right"></i>
                    </span>
                    <span *ngIf="sendOtpDisabled && cooldownTimer > 0">Please wait {{cooldownTimer}}s</span>
                    <span *ngIf="btnLoading && !sendOtpDisabled" class="otp-btn__content">
                        <span class="otp-spinner"></span>
                        <span>Sending...</span>
                    </span>
                </button>

                <button *ngIf="verifyOtpState && !pageLoading" 
                        class="otp-btn" 
                        [disabled]="btnLoading || otpValue?.length != 6" 
                        (click)="verifyOtp()">
                    <span *ngIf="!btnLoading" class="otp-btn__content">
                        <i class="pi pi-check-circle"></i>
                        <span>Verify & Continue</span>
                    </span>
                    <span *ngIf="btnLoading" class="otp-btn__content">
                        <span class="otp-spinner"></span>
                        <span>Verifying...</span>
                    </span>
                </button>
            </ng-container>

            <div class="otp-loading" *ngIf="pageLoading">
                <p-progressSpinner [style]="{height: '30px', width: '30px'}" 
                                   strokeWidth="7" 
                                   animationDuration="0.5s">
                </p-progressSpinner>
            </div>
        </div>
    </div>

    <div class="otp-security" *ngIf="!pageLoading && !isVerifying && verifyCategory !== 'test' && verifyCategory !== 'walkin'">
        <i class="pi pi-lock"></i>
        <span>Your information is secure and encrypted</span>
    </div>
</div>

<button *ngIf="showCrispBtn"
        class="crisp-fab"
        (click)="openCrispChat()"
        type="button"
        title="Chat with Support"
        aria-label="Chat with Support">
    <i class="pi pi-comment"></i>
</button>
